/**
 * Scroll-reveal: day and card sections fade-rise in as they enter the
 * viewport. Above-the-fold elements are never touched (no pop-in flash), and
 * prefers-reduced-motion disables the whole thing. Print always sees full
 * opacity via the app.css print override.
 */
let obs: IntersectionObserver | null = null;

export function initReveal() {
  if (matchMedia("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) return;
  obs?.disconnect();
  obs = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          obs!.unobserve(e.target);
        }
      }
    },
    { rootMargin: "0px 0px -6% 0px", threshold: 0.05 }
  );
  for (const el of document.querySelectorAll<HTMLElement>("section.day, .booklist")) {
    if (el.classList.contains("in")) continue;
    if (el.getBoundingClientRect().top < innerHeight * 0.92) continue; // already visible
    el.classList.add("reveal");
    obs.observe(el);
  }
}
